import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { takeEvery, takeLatest, put, fork, race, delay } from 'redux-saga/effects';
import { isEmpty } from 'lodash';
import { select, call, take } from 'typed-redux-saga';
import * as api from 'data/api';
import * as sessionSelectors from 'state/session/selectors';
import * as catalogFilterSelectors from 'state/catalog-filters/selectors';
import { actions as catalogFilterActions } from 'state/catalog-filters/slice';
import { saveFirstTimeSubscribe, isSavedSearchUser } from './utils';
import { filtersToApiParams, searchDtoToApiParams } from './transformers';
import * as statelessActions from './actions';
import { actions } from './slice';
import * as selectors from './selectors';
import { SEARCH_CHECK_DEBOUNCE_AMOUNT } from './constants';
export function* fetchSearches(_ref) {
  let {
    payload
  } = _ref;
  const {
    userId
  } = payload;
  const response = yield* call(api.getSortedSavedSearches, userId);

  if ('errors' in response) {
    yield put(statelessActions.fetchSearchesFailure());
    return;
  }

  yield put(actions.fetchSearchesSuccess({
    searches: response.searches
  }));
}
export function* fetchSearch(_ref2) {
  let {
    payload
  } = _ref2;
  const {
    userId,
    searchId
  } = payload;
  const response = yield* call(api.getSavedSearch, {
    id: searchId,
    userId
  });

  if ('errors' in response) {
    yield put(statelessActions.fetchSearchFailure());
    return;
  }

  yield put(actions.fetchSearchSuccess({
    search: response.search
  }));
}
export function* createSearch(_ref3) {
  let {
    payload
  } = _ref3;
  const {
    userId,
    search
  } = payload;
  const response = yield* call(api.createSavedSearch, {
    userId,
    search
  });

  if ('errors' in response) {
    yield put(statelessActions.createSearchFailure());
    return;
  }

  yield put(statelessActions.createSearchSuccess({
    searchId: response.search.id
  }));
}
export function* updateSearch(_ref4) {
  let {
    payload
  } = _ref4;
  const {
    searchId,
    userId,
    search,
    keepLastVisitTime
  } = payload;
  const params = {
    userId,
    search,
    keepLastVisitTime
  };
  const response = yield* call(api.updateSavedSearch, _objectSpread({
    id: searchId
  }, params));

  if ('errors' in response) {
    yield put(statelessActions.updateSearchFailure());
    return;
  }

  yield put(statelessActions.updateSearchSuccess());
}
export function* showSearchSubscriptionEducation() {
  const userHasUsedSavedSearches = yield* call(isSavedSearchUser);

  if (!userHasUsedSavedSearches) {
    yield call(saveFirstTimeSubscribe);
    yield put(actions.openSubscribeModal());
  }
} // Since the API does not return a full search object on create or update requests, we must send
// an additional request to get the full data and put it in the store.

export function* refreshSearchesAfterSave(_ref5) {
  let {
    userId
  } = _ref5;
  yield take([statelessActions.createSearchSuccess, statelessActions.updateSearchSuccess]);
  yield put(statelessActions.fetchSearchesRequest({
    userId
  }));
}
export function* setCurrentSearch() {
  const winner = yield race({
    success: take(statelessActions.createSearchSuccess),
    failure: take(statelessActions.createSearchFailure)
  });
  if (!winner.success) return;
  yield put(actions.setCurrentSearch({
    currentSearchId: winner.success.payload.searchId
  }));
}
export function* toggleSearchSubscriptionFlow(_ref6) {
  let {
    payload
  } = _ref6;
  const {
    userId,
    searchId
  } = payload;
  const search = yield* select(selectors.getSearchById, searchId);
  if (!search) return;
  yield fork(showSearchSubscriptionEducation);

  const searchParams = _objectSpread(_objectSpread({}, searchDtoToApiParams(search)), {}, {
    subscribed: !search.subscribed
  });

  yield put(statelessActions.updateSearchRequest({
    searchId,
    userId,
    search: searchParams,
    keepLastVisitTime: true
  }));
  yield fork(refreshSearchesAfterSave, {
    userId
  });
}
export function* toggleCurrentSearchSubscriptionFlow(_ref7) {
  let {
    payload
  } = _ref7;
  const {
    userId
  } = payload;
  const search = yield* select(selectors.getCurrentSearch);
  yield fork(showSearchSubscriptionEducation);

  if (search) {
    const searchParams = _objectSpread(_objectSpread({}, searchDtoToApiParams(search)), {}, {
      subscribed: !search.subscribed
    });

    yield put(statelessActions.updateSearchRequest({
      searchId: search.id,
      userId,
      search: searchParams,
      keepLastVisitTime: true
    }));
    yield fork(refreshSearchesAfterSave, {
      userId
    });
  } else {
    const filters = yield* select(catalogFilterSelectors.getFilters);
    const selectedDynamicFilters = yield* select(catalogFilterSelectors.getSelectedDynamicFilters);

    const searchParams = _objectSpread(_objectSpread({}, filtersToApiParams(filters, selectedDynamicFilters)), {}, {
      subscribed: true
    });

    yield put(statelessActions.createSearchRequest({
      userId,
      search: searchParams
    }));
    yield fork(setCurrentSearch);
    yield fork(refreshSearchesAfterSave, {
      userId
    });
  }
}
export function* currentSearchFlow() {
  yield delay(SEARCH_CHECK_DEBOUNCE_AMOUNT);
  const currentSearchId = yield* select(selectors.getCurrentSearchId);
  const userId = yield* select(sessionSelectors.getUserId);
  const filters = yield* select(catalogFilterSelectors.getFilters);
  const selectedDynamicFilters = yield* select(catalogFilterSelectors.getSelectedDynamicFilters);
  const isPopularCatalog = yield* select(catalogFilterSelectors.getIsPopularInCatalog);
  const searchParams = filtersToApiParams(filters, selectedDynamicFilters);
  if (!userId || isPopularCatalog) return;
  yield fork(refreshSearchesAfterSave, {
    userId
  });

  if (currentSearchId) {
    var _search;

    let search = yield* select(selectors.getCurrentSearch);

    if (!search) {
      yield put(statelessActions.fetchSearchRequest({
        userId,
        searchId: currentSearchId
      }));
      const action = yield* take(actions.fetchSearchSuccess);
      search = action.payload.search;
    }

    if (!isEmpty(filters.query) && filters.query !== ((_search = search) === null || _search === void 0 ? void 0 : _search.search_text)) {
      yield put(statelessActions.createSearchRequest({
        userId,
        search: searchParams
      }));
      yield fork(setCurrentSearch);
    } else {
      yield put(statelessActions.updateSearchRequest({
        searchId: currentSearchId,
        userId,
        search: _objectSpread(_objectSpread({}, searchParams), {}, {
          subscribed: search.subscribed
        }),
        keepLastVisitTime: false
      }));
    }
  } else {
    if (isEmpty(filters.query)) return;
    yield put(statelessActions.createSearchRequest({
      userId,
      search: searchParams
    }));
    yield fork(setCurrentSearch);
  }
}
export default function* saga() {
  yield takeLatest(statelessActions.fetchSearchesRequest, fetchSearches);
  yield takeEvery(statelessActions.fetchSearchRequest, fetchSearch);
  yield takeEvery(statelessActions.createSearchRequest, createSearch);
  yield takeEvery(statelessActions.updateSearchRequest, updateSearch); // User action invoked flows

  yield takeEvery(statelessActions.toggleSearchSubscription, toggleSearchSubscriptionFlow);
  yield takeEvery(statelessActions.toggleCurrentSearchSubscription, toggleCurrentSearchSubscriptionFlow);
  yield takeLatest([statelessActions.checkCurrentSearch, catalogFilterActions.changeFilters, catalogFilterActions.setInitialFilters], currentSearchFlow);
}